export default __webpack_public_path__ + "static/media/otp-fillable.ef92c6d5.pdf";